var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfiles = function SvgProfiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "var(--icon-stroke-width, 1.5)",
    d: "M16.752 11.582c1.188.888 2.25 3.123 2.25 4.5 0 .429-.313.777-.7.777h-.425m-4.5-8.916a2.57 2.57 0 0 0 0-4.455M1.701 16.858h12.316c.386 0 .7-.347.7-.776 0-2.697-2.254-4.883-6.858-4.883-4.604 0-6.857 2.186-6.857 4.883 0 .429.313.777.7.777Zm8.73-11.142a2.571 2.571 0 1 1-5.143 0 2.571 2.571 0 0 1 5.143 0Z"
  })));
};
export default SvgProfiles;